import firebase from 'firebase/app';
import 'firebase/database'; // If using Firebase database
import 'firebase/storage';  // If using Firebase storage
import 'firebase/auth';  // If using Firebase storageBucket
import 'firebase/firestore';  // If using Firebase storage
//insert config from firebase
const firebaseConfig = {
    apiKey: "AIzaSyBkjcrwROVAZQFdYZldydPxElTF5h9tDiE",
    authDomain: "qadmin-2537.firebaseapp.com",
    databaseURL: "https://qadmin-2537.firebaseio.com",
    projectId: "qadmin-2537",
    storageBucket: "qadmin-2537.appspot.com",
    messagingSenderId: "532567556551",
    appId: "1:532567556551:web:5240731973a9e3385059e2"
};

firebase.initializeApp(firebaseConfig);
export { firebase as default };